import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { BONOS, PRICING } from '../../data/content';
export function Bonos() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-17" data-mp="1hipuewkgrcdd">
      <div className="mx-auto max-w-5xl" data-id="element-18" data-mp="1hhepuuj720l7">
        <Reveal className="text-center" data-id="element-19" data-mp="1ckeh2buymjqe">
          <SectionBadge data-id="element-20" data-mp="1cilb6ys683jg">Regalo incluido</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-21" data-mp="oubxyl90wo3x">
            Y además recibís <span className="u-lime" data-id="element-22" data-mp="jxlhvxx7xsii">5 bonos exclusivos</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-snow-muted sm:text-base" data-id="element-23" data-mp="ylyemx44rfe2">
            Incluidos <strong className="font-bold text-snow" data-id="element-24" data-mp="tteqx7bqb3vj">GRATIS</strong> con tu compra de hoy.
          </p>
        </Reveal>

        <div className="mt-8 grid gap-3.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="62rh2gi9646c">
          {BONOS.map((bono, index) => <Reveal key={bono.n} delay={index % 3 * 80} as="article" data-id="element-26" data-mp="1596ymsi1iwr" data-mpi={index}>
              <div className="flex h-full flex-col rounded-2xl border border-ink-line bg-ink p-5" data-id="element-27" data-mp="2z9meqksc5ktd">
                <div className="flex items-center justify-between" data-id="element-28" data-mp="3487gion8kcjx">
                  <span className="text-[10px] font-extrabold uppercase tracking-[0.18em] text-snow-dim" data-id="element-29" data-mp="38zp5eebzimoj">
                    Bono {bono.n}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-lime px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wide text-ink" data-id="element-30" data-mp="3d3wtqaej60m8">
                    <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-31" data-mp="2lbfo9pppun3q" /> Gratis
                  </span>
                </div>

                <img src={bono.mockup} alt={`Portada del bono ${bono.n}: ${bono.title}`} width={144} height={192} sizes="108px" loading="lazy" fetchPriority="low" decoding="async" className="mx-auto mt-4 h-40 w-auto rounded-lg object-contain" data-id="element-32" data-mp="2paww2psm7wc2" />

                <h3 className="mt-4 text-sm font-bold leading-snug text-snow" data-id="element-33" data-mp="9kkelrget007">{bono.title}</h3>
                <div className="flex-1" data-id="element-34" data-mp="25nynu7eeuh4u">
                  <p className="mt-1.5 text-sm leading-relaxed text-snow-muted" data-id="element-35" data-mp="25mngxypo4t9i">{bono.desc}</p>
                  {bono.items && <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-36" data-mp="21mddaspcmext">
                      {bono.items.map(item => <li key={item} className="rounded-full border border-ink-line bg-ink-soft px-2.5 py-0.5 text-xs font-semibold text-snow" data-id="element-37" data-mp="2flw86jt5fts6">
                          {item}
                        </li>)}
                    </ul>}
                  {bono.note && <p className="mt-2 text-sm leading-relaxed text-snow" data-id="element-38" data-mp="1hynpewkj8ytv">{bono.note}</p>}
                </div>
                <p className="mt-3.5 text-xs font-semibold text-snow-dim" data-id="element-39" data-mp="1wna9fbl3uerf">
                  Valor <span className="line-through" data-id="element-40" data-mp="1rwts3ge5y8zs">{bono.price}</span> ·{' '}
                  <span className="font-extrabold text-lime" data-id="element-41" data-mp="1rvimdb15qr61">HOY: GRATIS</span>
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={110} className="mt-6 text-center" data-id="element-42" data-mp="z8xywlnsyz7r">
          <p className="inline-block rounded-full border border-ink-line bg-ink px-6 py-3 text-sm font-bold text-snow" data-id="element-43" data-mp="z6bs4o8qknql">
            Bonos valuados en <span className="text-snow-dim line-through" data-id="element-44" data-mp="3fmhulgg6bdle">{PRICING.bonusValueOld}</span>{' '}
            <span className="text-lime" data-id="element-45" data-mp="31vd2czf4xnl3">— incluidos sin costo</span>
          </p>
        </Reveal>
      </div>
    </section>;
}